export default "__VITE_PUBLIC_ASSET__7a65e0d7__"